export function consoleError(...rest) {
  console.error(...rest)
}
